import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import axios, { API_URL } from '../../utils/axiosConfig';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSuccess(true);
      setEmail(''); // Clear form
    } catch (error) {
      setError(error.response?.data?.error || 'Erreur lors de l\'envoi de l\'email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center justify-center mb-4">
          <Mail className="w-12 h-12 text-blue-900" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">Mot de passe oublié ?</h2>
        <p className="text-sm text-gray-600 text-center mb-4">
          Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded mb-3 text-sm">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-3 py-2 rounded mb-3 text-sm">
            <strong>Email envoyé !</strong>
            <p className="mt-1">
              Si cette adresse email existe dans notre système, vous recevrez un lien de réinitialisation dans quelques minutes.
            </p>
            <p className="mt-1 text-xs">
              Vérifiez aussi vos spams si vous ne le trouvez pas.
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent"
              placeholder="votre-email@example.com"
              required
              disabled={success}
            />
          </div>

          {!success && (
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-900 text-white py-2 text-sm rounded-lg hover:bg-blue-950 transition font-semibold disabled:bg-gray-400"
            >
              {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
            </button>
          )}
        </form>

        <div className="mt-4 text-center space-y-2">
          <button
            onClick={() => navigate('/login')}
            className="text-blue-900 hover:underline text-sm font-semibold"
          >
            ← Retour à la connexion
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
